// extracted by mini-css-extract-plugin
export default {"root":"carousel_root__HVMAe","sliderControls":"carousel_sliderControls__EO+M3"};